// extracted by mini-css-extract-plugin
export default {"wrapperPopover":"PopoverComponent_wrapperPopover__2wTbR","arrowBox":"PopoverComponent_arrowBox__K8B-K"};